import React from "react";
import "./Policy.css";
import { Paper, Button } from "@material-ui/core";

let langData = require("../../../Data/language.json");
const langPolicy = require("../../../Data/languagePolicy.json");

export default function Policy(props) {
  return (
    <div className="container-fluid col-lg-8 col-md-11 col-sm-11">
      <Paper
        className="container-fluid"
        id="logInContainer"
        elevation={6}
        square
      >
        <div className="inputWrapper">
          <Button
            variant="outlined"
            onClick={() => props.toggleInputMode("login")}
          >
            {langData[props.language].register.backBtn}
          </Button>
        </div>
        <div>
          <hr></hr>
          <h2>{langPolicy[props.language].policy.dataPolicyTitle}</h2>
          <div>
            <h5>{langPolicy[props.language].policy.generalTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.generalText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.generalText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.generalText3}
            </p>
            <p className="policyText">
              {langPolicy[props.language].generalText4}
            </p>

            <h5>{langPolicy[props.language].policy.personalDataTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.personalDataText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.personalDataText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.personalDataText3}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.personalDataText4}
            </p>

            <h5>
              {langPolicy[props.language].policy.handlingPersonalDataTitle}
            </h5>
            <p className="policyText">
              {langPolicy[props.language].policy.handlingPersonalDataText1}
            </p>

            <h5>
              {langPolicy[props.language].policy.transferingPersonalDataTitle}
            </h5>
            <p className="policyText">
              {langPolicy[props.language].policy.transferingPersonalDataText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.transferingPersonalDataText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.transferingPersonalDataText3}
            </p>

            <h5>
              {langPolicy[props.language].policy.rightsForRegisteredTitle}
            </h5>
            <p className="policyText">
              {langPolicy[props.language].policy.rightsForRegisteredText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.rightsForRegisteredText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.rightsForRegisteredText3}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.rightsForRegisteredText4}
            </p>

            <h5>{langPolicy[props.language].policy.safetyTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.safetyText1}
            </p>

            <h5>{langPolicy[props.language].policy.changesPolicyTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.changesPolicyText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.changesPolicyText2}
            </p>

            <h5>{langPolicy[props.language].policy.contactPolicyTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.contactPolicyText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].policy.contactPolicyText2}
            </p>

            <h5>{langPolicy[props.language].policy.dateTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].policy.dateText1}
            </p>
          </div>
          <hr></hr>
          <h2>{langPolicy[props.language].terms.termsTitle}</h2>
          <div>
            <p className="policyText">
              {langPolicy[props.language].terms.termsGeneralText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.termsGeneralText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.termsGeneralText3}
            </p>

            <h5>{langPolicy[props.language].terms.profileTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.profileText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.profileText2}
            </p>

            <h5>{langPolicy[props.language].terms.ourRightsTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.ourRightsText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.ourRightsText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.ourRightsText3}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.ourRightsText4}
            </p>

            <h5>{langPolicy[props.language].terms.personalInfoTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.personalInfoText1}
            </p>

            <h5>{langPolicy[props.language].terms.maintenanceTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.maintenanceText1}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.maintenanceText2}
            </p>
            <p className="policyText">
              {langPolicy[props.language].terms.maintenanceText3}
            </p>

            <h5>{langPolicy[props.language].terms.userRestrictionTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.userRestrictionText1}
            </p>

            <h5>{langPolicy[props.language].terms.modificationTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.modificationText1}
            </p>

            <h5>{langPolicy[props.language].terms.disputesTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.disputesText1}
            </p>

            <h5>{langPolicy[props.language].terms.contactTitle}</h5>
            <p className="policyText">
              {langPolicy[props.language].terms.contactText1}
            </p>
            <hr></hr>
          </div>
        </div>
        <div className="inputWrapper">
          <Button
            variant="outlined"
            onClick={() => props.toggleInputMode("login")}
          >
            {langData[props.language].register.backBtn}
          </Button>
        </div>
      </Paper>
    </div>
  );
}
